import { API } from '@/shared/api/modules';
import type { GetMarginRequestDto } from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getFacilitiesMarginQueryOptions = (
  params = {} as GetMarginRequestDto
) =>
  queryOptions({
    queryKey: ['facilities-margin', params],
    queryFn: async ({ signal }) => {
      return await API.facilities.getMargin(params, { signal });
    },
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    enabled: !!params.from && !!params.to,
  });
